import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-copyright">
            © 2025 All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 